import styled from 'styled-components';
import StockModelCardDealerInfoTemplate from './StockModelCardDealerInfoTemplate';
import { rem } from 'polished';

export const DealerLocation = styled.div``;

export const StockModelCardDealerInfoStyled = styled(StockModelCardDealerInfoTemplate)`
    /* Selectors are in mark up order => dont change spacifity and keep it this way! */
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    h6 {
        padding: 0 ${rem('15px')};
        margin: ${rem('25px')} 0 0 0;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.grey11};
        font-size: ${rem('14px')};
    }

    .finance-upLabel {
        display: inline-block;
        transform: translateY(${rem('10px')});
    }

    .date-icon {
        padding-right: ${rem('5px')};
    }

    .stockModelCard-dealerInfo {
        &--ctaSection {
            padding: ${rem('5px')} ${rem('25px')} ${rem('13px')};
            font-size: ${({ theme }) => theme.fontSizes.textSmall};
            color: ${({ theme }) => theme.colors.grey11};
            display: flex;
            align-items: center;
        }

        &--priceContainer {
            min-width: 50%;
        }
    }

    .price {
        display: flex;
        align-items: baseline;
        color: ${({ theme }) => theme.colors.black3};
        font-size: ${rem('20px')};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        .monthly-desc {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            display: inline-block;
            margin-left: ${rem('5px')};
        }
    }

    .infoIcon {
        display: inline-block;
        height: ${rem('35px')};
    }

    .date {
        margin: ${rem('15px')};
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        display: flex;

        &-icon {
            path:first-of-type {
                fill: ${({ theme }) => theme.colors.primary};
            }

            path:last-of-type {
                stroke: ${({ theme }) => theme.colors.primary};
            }
        }

        &-caption {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            margin-left: ${rem('8px')};
        }
    }

    .stockModelCard-dealerInfo--legalText {
        font-size: ${rem('12px')};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .keywords {
        padding: ${rem('15px')} ${rem('15px')} ${rem('25px')};
        font-size: ${({ theme }) => theme.fontSizes.textSmall};
        color: ${({ theme }) => theme.colors.grey11};
    }

    .dealer-location {
        display: flex;
        align-items: flex-start;
        margin: 0 ${rem('15px')} ${rem('15px')};
        background: ${({ theme }) => theme.colors.trimPageModelNameBackground};
        padding: ${rem('10px')};
        min-height: ${rem('50px')};
        &--info {
            display: flex;
            flex-direction: column;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        &--icon {
            margin-right: 0;

            path {
                fill: ${({ theme }) => theme.colors.primary};
            }
        }

        &--address {
            text-transform: uppercase;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            margin-top: ${rem('5px')};
            font-size: ${rem('12px')};
        }

        .icon-wrapper {
            height: ${rem('16px')};
        }
    }
`;
